var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAdac = function SvgAdac(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 608.9 609.7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h608.9v609.7H0Z",
    fill: "#ffcf00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.28 216.6h36.91L74 178.5h41.11l6.82 38.1h45.33l-37.7-184.51H70.8ZM95.47 70.2h.4l13 76.21H80.23Z",
    fill: "#231f1f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M179.5 216.6h55.16c55.35 0 76.81-44.12 76.81-96.26 0-54.15-26.27-88.25-82.43-88.25H179.5Zm45.73-152.42H229c30.28 0 33.29 34.09 33.29 54.15 0 24.07 0 64.18-32.09 64.18h-5V64.18m80.85 152.42h38.11l8-38.1h42.34l7.22 38.1h46.73L409.34 32.09H349L306.05 216.6Zm68.19-146.4h.61l13.23 76.21H358.6ZM538.1 96.27c0-12-3.21-34.1-19.65-34.1-19.25 0-22.06 28.08-22.06 62.18 0 38.1 1.8 60.16 23.06 60.16 16.85 0 20.66-14 21.66-36.1l39.51 4c0 40.11-23.66 66.18-63.18 66.18-55.35 0-70.39-46.13-70.39-94.26 0-46.13 14.84-96.27 70.39-96.27 43.73 0 63.18 30.08 63.18 68.19Z",
    fill: "#231e1f"
  })));
};

export default SvgAdac;